"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSeoFilenameProperty = exports.seoFilenamePropertyDefinition = void 0;
exports.seoFilenamePropertyDefinition = {
    view: {
        label: 'SEO filename',
        style: '',
        hint: 'Used for the filename in the URL. Should contain the keywords separated by dashes. Allowed characters are a-z, A-Z, 0-9, ~, _ and -. Example: red-bull-bc-one-camp-annonce-social',
    },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'pattern',
            argument: '^[\\w~-]*$',
        },
    ],
    type: 'text',
    multiple: false,
    name: 'seo-filename',
};
const isSeoFilenameProperty = (prop) => {
    return prop.name === exports.seoFilenamePropertyDefinition.name;
};
exports.isSeoFilenameProperty = isSeoFilenameProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VvLWZpbGVuYW1lLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvc2VvLWZpbGVuYW1lLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsNkJBQTZCLEdBQUc7SUFDM0MsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLGNBQWM7UUFDckIsS0FBSyxFQUFFLEVBQUU7UUFDVCxJQUFJLEVBQUUsbUxBQW1MO0tBQzFMO0lBQ0QsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsSUFBSTtTQUNmO1FBQ0Q7WUFDRSxJQUFJLEVBQUUsU0FBUztZQUNmLFFBQVEsRUFBRSxZQUFZO1NBQ3ZCO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsTUFBTTtJQUNaLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLGNBQWM7Q0FDVyxDQUFBO0FBSTFCLE1BQU0scUJBQXFCLEdBQUcsQ0FBQyxJQUFrQixFQUErQixFQUFFO0lBQ3ZGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxxQ0FBNkIsQ0FBQyxJQUFJLENBQUE7QUFDekQsQ0FBQyxDQUFBO0FBRlksUUFBQSxxQkFBcUIseUJBRWpDIn0=